import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * VAPT-08 (CWE-598): exchange the long-lived session JWT for a short-lived
 * (5 min), resource-scoped download token, so file URLs opened in a new tab
 * never carry the session JWT in the query string (which leaks into access
 * logs, browser history and Referer headers).
 *
 * @param {('sheerdrive-pdf'|'full-report-pdf'|'report-html'|'cached-pdf'|'service-history-pdf')} type
 * @param {string|number} id - inspection_id or cache_key the endpoint expects
 * @returns {Promise<string>} scoped token to append as ?token=
 */
export async function getDownloadToken(type, id) {
  const session =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!session) throw new Error("Not authenticated");
  const { data } = await axios.post(
    `${API}/api/auth/download-token`,
    { type, id: String(id) },
    { headers: { Authorization: `Bearer ${session}` } },
  );
  return data.token;
}
